export default __webpack_public_path__ + "static/media/frontBody.c6385704.png";